<div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px">
  <span>Start this task</span>

  <ng-container>
    <button mat-flat-button class="filter__option-btn button__small button__text" [matMenuTriggerFor]="timingMenu">
      <span>{{ ruleset.timing.unit.value_label }}</span>
    </button>
  </ng-container>

  <button mat-flat-button class="filter__option-btn button__small button__text" [matMenuTriggerFor]="whenMenu">
    <span>{{ ruleset.timing.when }}</span>
  </button>

  <button mat-flat-button class="filter__option-btn button__small button__text" [matMenuTriggerFor]="checkMenu">
    <span>{{ ruleset.relative_to_label }}</span>
  </button>

  <mat-menu #timingMenu="matMenu" class="filters__cdk-menu">
    <ng-template matMenuContent>
      <mat-radio-group fxLayout="column" class="filters__input-number-rg" (change)="unitsChanged($event)">
        <ng-container *ngFor="let unit of meta.units">
          <ng-container [ngSwitch]="unit.type">
            <ng-container *ngSwitchCase="'static'">
              <mat-radio-button [value]="unit">{{ unit.text }}</mat-radio-button>
            </ng-container>

            <ng-container *ngSwitchCase="'int'">
              <mat-radio-button
                [value]="unit"
                [checked]="unit.value_append === ruleset.timing.unit.value_append"
                (click)="$event.stopPropagation()">
                {{ unit.text_after }}
              </mat-radio-button>
              <mat-form-field
                *ngIf="unit.value_append === ruleset.timing.unit.value_append"
                (click)="$event.stopPropagation()">
                <input
                  matInput
                  type="number"
                  [value]="ruleset.timing.unit.value"
                  (change)="unitIntInputChange($event, unit)" />
              </mat-form-field>
            </ng-container>
          </ng-container>
        </ng-container>
      </mat-radio-group>

      <button class="filter__btn-done">Done</button>
    </ng-template>
  </mat-menu>

  <mat-menu #whenMenu="matMenu" class="filters__cdk-menu">
    <button
      *ngIf="ruleset.task_type === 5 || (ruleset.task_type !== 4 && ruleset.relative_to === 'checkin')"
      mat-menu-item
      (click)="whenChanged('before')">
      before
    </button>
    <button
      *ngIf="ruleset.task_type !== 2 && !(ruleset.task_type === 1 && ruleset.relative_to === 'checkin')"
      mat-menu-item
      (click)="whenChanged('after')">
      after
    </button>
  </mat-menu>

  <mat-menu #checkMenu="matMenu" class="filters__cdk-menu">
    <button *ngIf="ruleset.task_type !== 4" mat-menu-item (click)="checkChanged('checkin')">
      the guest's check-in
    </button>
    <button *ngIf="ruleset.task_type !== 2" mat-menu-item (click)="checkChanged('checkout')">
      the guest's check-out
    </button>
  </mat-menu>
</div>
